export enum Grant {
    CREATE_OFFER = 'CREATE_OFFER',
    DELETE_OFFER = 'DELETE_OFFER',
    SEND_OFFER = 'SEND_OFFER',
    DOWNLOAD_OFFER = 'DOWNLOAD_OFFER',
    CREATE_PRICE_FIELD = 'CREATE_PRICE_FIELD',
    EDIT_PRICE_FIELD = 'EDIT_PRICE_FIELD',
    DELETE_PRICE_FIELD = 'DELETE_PRICE_FIELD',
    CREATE_ZONE = 'CREATE_ZONE',
    EDIT_ZONE = 'EDIT_ZONE',
    CREATE_ROLE = 'CREATE_ROLE',
    ASSIGN_ROLE = 'ASSIGN_ROLE',
    EDIT_ROLE = 'EDIT_ROLE',
    INVITE_USER = 'INVITE_USER',
}

export const GrantDescription = {
    [Grant.CREATE_OFFER]: 'Lage nytt anbud',
    [Grant.DELETE_OFFER]: 'Slette et anbud',
    [Grant.SEND_OFFER]: 'Sende et anbud',
    [Grant.DOWNLOAD_OFFER]: 'Laste ned anbud',
    [Grant.CREATE_PRICE_FIELD]: 'Lage nytt prisfelt',
    [Grant.EDIT_PRICE_FIELD]: 'Endre på prisfelt',
    [Grant.DELETE_PRICE_FIELD]: 'Slette prisfelt',
    [Grant.ASSIGN_ROLE]: 'Gi noen en rolle',
    [Grant.INVITE_USER]: 'Invitere en bruker til organisasjonen',
}